import React, { Component } from "react";
import { Card, Row, Col } from "antd";
import { Fragment } from "react";
import moment from "moment";

export default class ProvidersDetail extends Component {
  render() {
    const providerInformation = this.props.providerInformation;
    const claimSummary = this.props.claimSummary;
    return (
      <Fragment>
        <Card className="pr-2 pb-2 mb-2 pl-3">
          <div className="m-2 details-header-sub pt-1">01. Billing Provider Information</div>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Billing Provider Name{" "}
              <div className="black-text">{providerInformation.billingProviderName ? providerInformation.billingProviderName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Tax ID{" "}
              <div className="black-text">{providerInformation.taxId ? providerInformation.taxId : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 01{" "}
              <div className="black-text">
                {providerInformation.billingProviderAddress1 ? providerInformation.billingProviderAddress1 : "---"}
              </div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 02{" "}
              <div className="black-text">
                {providerInformation.billingProviderAddress2 ? providerInformation.billingProviderAddress2 : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              City
              <div className="black-text">
                {providerInformation.billingProviderCity ? providerInformation.billingProviderCity : "---"}
              </div>
            </Col>
          </Row>

          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              State
              <div className="black-text">{providerInformation.billingProviderState ? providerInformation.billingProviderState : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Zip
              <div className="black-text">{providerInformation.billingProviderZipCode ? providerInformation.billingProviderZipCode : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Taxonomy
              <div className="black-text">{providerInformation.billingProviderTaxonomy ? providerInformation.billingProviderTaxonomy : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              SSN
              <div className="black-text">
                {providerInformation.billingProviderSsn ? providerInformation.billingProviderSsn : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Telephone
              <div className="black-text">
                {providerInformation.billingProviderTelephone ? providerInformation.billingProviderTelephone : "---"}
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Network Affiliation <div className="black-text">{providerInformation.networkAffiliation ? providerInformation.networkAffiliation : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1" style={{marginRight:"58%"}}>
            Timely Filing Limit <div className="black-text">{providerInformation.timelyFiling ? providerInformation.timelyFiling : "---"}</div>
            </Col>
          </Row>
        </Card>

        <Card className="pr-2 pb-2 mb-2 pl-3 mt-3">
          <div className="m-2 details-header-sub pt-1">02. Pay to Provider Information</div>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Pay-To-Provider ID{" "}
              <div className="black-text">{providerInformation.payToProviderId ? providerInformation.payToProviderId : "---"}</div>
            </Col>
            <Col span={6} className="details-header-row pr-1">
              Pay-To-Provider Name{" "}
              <div className="black-text">{providerInformation.payToProviderName ? providerInformation.payToProviderName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Tax ID/SSN{" "}
              <div className="black-text">{providerInformation.taxId ? providerInformation.taxId : "---"}</div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              NPI{" "}
              <div className="black-text">
              {providerInformation.npi ? providerInformation.npi : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Vendor ID{" "}
              <div className="black-text">
              {providerInformation.vendorId ? providerInformation.vendorId : "---"}
              </div>
            </Col>
          </Row>

          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Vendor Validated{" "}
              <div className="black-text">{providerInformation.vendorValidated ? "Validated" : "Not Validated"}</div>
            </Col>
            <Col span={6} className="details-header-row pr-1">
              Address 01{" "}
              <div className="black-text">{providerInformation.addressLine1 ? providerInformation.addressLine1 : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 02{" "}
              <div className="black-text">{providerInformation.addressLine2 ? providerInformation.addressLine2 : "---"}</div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              City{" "}
              <div className="black-text">
              {providerInformation.city ? providerInformation.city : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              State{" "}
              <div className="black-text" style={{ marginLeft: "2px" }}>
              {providerInformation.state ? providerInformation.state : "---"}
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              ZIP <div className="black-text">{providerInformation.zipCode ? providerInformation.zipCode : "---"}</div>
            </Col>
          </Row>
        </Card>

        <Card className="pb-4 mb-2 px-3 mt-3">
          <div className="m-2 pt-1 details-header-sub">03. Rendering Provider List</div>
          <div style={{ color: "#646464", fontWeight: "lighter" }}>
            <Row className="mx-3 mt-3">
              <Col span={1} className="grey-text pr-1">
                {" "}
                #
              </Col>
              <Col span={2} className="grey-text pr-1">
                Effective
              </Col>
              <Col span={2} className="grey-text pr-1">
                Term
              </Col>
              <Col span={4} className="grey-text pr-1">
                Name
              </Col>
              <Col span={4} className="grey-text pr-1">
                Address
              </Col>
              <Col span={3} className="grey-text pr-1">
                NPI
              </Col>
              <Col span={3} className="grey-text pr-1">
                Speciality
              </Col>
              <Col span={3} className="grey-text pr-1">
                Provider ID
              </Col>
              <Col span={2} className="grey-text pr-1">
                Contract Name
              </Col>
            </Row>
          </div>
          <br />

          <div>
            <Row>
              <Col className="pointer" span={24} xs={24}>
                <div
                  className="claims-card-background py-2"
                  style={{
                    color: "#646464",
                    fontWeight: "lighter",
                    fontSize: "12px"
                  }}
                >
                  <Row className="mx-2 pb-2">
                    <Col span={1} className="pr-1">
                      <b>01.</b>
                    </Col>
                    <Col span={2} className="pr-1">
                      <div>{providerInformation.renderingProviderEffective ? moment(new Date(providerInformation.renderingProviderEffective)).format("ll") : "---"}</div>
                    </Col>
                    <Col span={2} className="pr-1">
                      <b>{providerInformation.renderingProviderTerm ? moment(new Date(providerInformation.renderingProviderTerm)).format("ll") : "---"}</b>
                    </Col>
                    <Col span={4} className="pr-1">
                      <b>{providerInformation.renderingProviderName ? providerInformation.renderingProviderName : "---"}</b>
                    </Col>
                    <Col span={4} className="pr-1">
                      <b>{providerInformation.renderingProviderAddress1 ? providerInformation.renderingProviderAddress1 : "---"}</b>
                    </Col>
                    <Col span={3} className="pr-1">
                      <b>{providerInformation.renderingProviderNpi ? providerInformation.renderingProviderNpi : "---"}</b>
                    </Col>
                    <Col span={3} className="pr-1">
                      <b>{providerInformation.renderingProviderSpecialty ? providerInformation.renderingProviderSpecialty : "---"}</b>
                    </Col>
                    <Col span={3} className="pr-1">
                      <b>{providerInformation.renderingProviderId ? providerInformation.renderingProviderId : "---"}</b>
                    </Col>
                    <Col span={2} className="pr-1">
                      <b>{providerInformation.renderingProviderContractName ? providerInformation.renderingProviderContractName : "---"}</b>
                    </Col>
                  </Row>
                </div>
                
              </Col>
            </Row>
          </div>
        </Card>
      
        {claimSummary.claimNumber && claimSummary.claimNumber[0] === "I" && 
        <Card className="pr-2 pb-2 mb-2 pl-3 mt-3">
          <div className="m-2 details-header-sub pt-1">04. Rendering Provider Information</div>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              Provider Name{" "}
              <div className="black-text">{providerInformation.renderingProviderName ? providerInformation.renderingProviderName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Federal Tax No.{" "}
              <div className="black-text">{providerInformation.taxId ? providerInformation.taxId : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 01{" "}
              <div className="black-text">
                {providerInformation.renderingProviderAddress1 ? providerInformation.renderingProviderAddress1 : "---"}
              </div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Address 02{" "}
              <div className="black-text">
                {providerInformation.renderingProviderAddress2 ? providerInformation.renderingProviderAddress2 : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              City
              <div className="black-text">
                {providerInformation.renderingProviderCity ? providerInformation.renderingProviderCity : "---"}
              </div>
            </Col>
          </Row>

          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
              State
              <div className="black-text">{providerInformation.renderingProviderState ? providerInformation.renderingProviderState : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Country
              <div className="black-text">{providerInformation.renderingProviderCountry ? providerInformation.renderingProviderCountry : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Zipcode
              <div className="black-text">{providerInformation.renderingProviderZip ? providerInformation.renderingProviderZip : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Contact No.
              <div className="black-text">
                {providerInformation.renderingProviderTelephone ? providerInformation.renderingProviderTelephone : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              NPI Rendering Provider
              <div className="black-text">
                {providerInformation.renderingProviderNpi ? providerInformation.renderingProviderNpi : "---"}
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mx-3" justify="space-between">
            <Col span={5} className="details-header-row pr-1">
            Attending Provider Name <div className="black-text">{providerInformation.attendingProviderFirstName ? providerInformation.attendingProviderFirstName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
            Attending Provider NPI <div className="black-text">{providerInformation.attendingProviderIdentifier ? providerInformation.attendingProviderIdentifier : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
            Other Provider Name <div className="black-text">{providerInformation.otherProviderName ? providerInformation.otherProviderName : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
            Operating Physician Name <div className="black-text">{providerInformation.operatingPhysicianName ? providerInformation.operatingPhysicianName : "---"}</div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Network Affiliation <div className="black-text">{providerInformation.networkAffiliation ? providerInformation.networkAffiliation : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1" style={{marginRight:"58%"}}>
            Timely Filing Limit <div className="black-text">{providerInformation.timelyFiling ? providerInformation.timelyFiling : "---"}</div>
            </Col>
          </Row>
        </Card>}

      </Fragment>
    );
  }
}
